// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Mv4C","tab":"Tabs_tab__1EGam","tabActive":"Tabs_tabActive__1zdIp"};